<div class="px-28 my-10 font-sans">
  <div>
    <div class="flex items-center justify-between my-2">
      <div class="flex items-center space-x-3">
        <button
          *ngIf="!isAuthenticated"
          (click)="loginWithOIDC()"
          class="
              uppercase
              bg-orange-forbes
              p-2
              font-light
              text-sm
              rounded-md
              text-white
              w-40
              h-14
            "
          >
          Login
          </button>
          
        <button
          *ngIf="isAuthenticated"
          (click)="continueToProductSelection()"
          class="
              uppercase
              bg-orange-forbes
              p-2
              font-light
              text-sm
              rounded-md
              text-white
              w-48
              h-14
              hover:bg-orange-600
              transition-colors
            "
          >
          View Your Products
          </button>
      </div>
        
      <button
        *ngIf="isAuthenticated"
        (click)="logout()"
        class="
            uppercase
            bg-red-600
            p-2
            font-light
            text-sm
            rounded-md
            text-white
            w-32
            h-14
            hover:bg-red-700
            transition-colors
          "
        >
        Logout
        </button>
      </div>
      
    <div *ngIf="isAuthenticated" class="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4">
      <p><strong>✓ You are already authenticated.</strong> Click "View Your Products" to proceed.</p>
    </div>
    <div class="text-sm">
      <p class="my-5 text-sm font-semibold">
        Remember to keep your login details private at all times.
      </p>
      <p>
        For more information see:
        <a
          href="{{ privacyPolicyLink }}"
          target="_blank"
          class="my-5 text-orange-forbes"
          >Privacy policy</a
        >
      </p>
      <p class="text-sm my-5">
        <span class="uppercase text-xs font-medium"
          >alexander forbes client data protection: </span
        >We are committed to protecting the integrity of all client information
        within an international best practice compliance framework. Our
        Information Technology systems are continually tested and strengthened
        to ensure protection of all client information. We remain vigilant to
        the possibility of cyber threats to our company and the financial
        services sector. Additional security measures in this regard are
        continually being assessed and implemented.
      </p>
    </div>
  </div>
</div>